import {
  useEffect,
  // useRef,
  useState,
} from "react";

function Paginator({
  page,
  totalCount,
  pageLimit,
  onPageChange,
  cursor,
  className,
  isLast,
}) {
  const [tempValue, setTempValue] = useState(page);
  const [totalPages, setTotalPages] = useState(
    Math.ceil(totalCount / pageLimit) > 0
      ? Math.ceil(totalCount / pageLimit)
      : 1
  );

  useEffect(() => {
    setTotalPages(
      Math.ceil(totalCount / pageLimit) > 0
        ? Math.ceil(totalCount / pageLimit)
        : 1
    );
    if (page > totalCount / pageLimit) handleBlur();
  }, [totalCount, pageLimit]);

  useEffect(() => {
    getPages();
  }, [totalPages, page]);

  const updatePage = (_page) => {
    _page !== page && onPageChange && onPageChange(_page);
  };

  const handleIncrement = () => {
    if (cursor) {
      updatePage(page + 1);
    } else {
      if (page < totalPages) {
        setTempValue(page + 1);
        updatePage(page + 1);
      }
    }
  };
  const handleDecrement = () => {
    if (page > 1) {
      setTempValue(page - 1);
      updatePage(page - 1);
    }
  };

  const handleBlur = () => {
    if (!isNaN(tempValue) && tempValue > 0) {
      if (tempValue <= totalPages) updatePage(tempValue);
      else {
        setTempValue(totalPages || 1);
        updatePage(totalPages || 1);
      }
    } else {
      setTempValue(1);
      updatePage(1);
    }
  };

  const chunkSize = 5;
  const [pages, setPages] = useState([<></>]);
  const getPages = () => {
    let _pages = [];
    if (totalPages <= chunkSize) {
      for (let i = 1; i <= totalPages; i++) {
        _pages.push(
          <span
            onClick={() => {
              updatePage(i);
            }}
            className={`${
              page === i ? "bg-gray-800 text-white" : "text-gray-500"
            } cursor-pointer relative hidden items-center px-4 py-2 text-sm   ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0 md:inline-flex`}
          >
            {i}
          </span>
        );
      }
    } else {
      if (page < chunkSize) {
        for (let i = 1; i <= chunkSize; i++) {
          _pages.push(
            <span
              onClick={() => {
                updatePage(i);
              }}
              className={`${
                page === i ? "bg-gray-800 text-white" : "text-gray-500"
              } cursor-pointer relative hidden items-center px-4 py-2 text-sm   ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0 md:inline-flex`}
            >
              {i}
            </span>
          );
        }
        _pages.push(
          <span className="relative hidden items-center px-4 py-2 text-sm  text-gray-500 ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0 md:inline-flex">
            ...
          </span>
        );
        _pages.push(
          <span
            onClick={() => {
              updatePage(totalPages);
            }}
            className={`${
              page === totalPages ? "bg-gray-800 text-white" : "text-gray-500"
            } cursor-pointer relative hidden items-center px-4 py-2 text-sm   ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0 md:inline-flex`}
          >
            {totalPages}
          </span>
        );
      } else if (totalPages - page < chunkSize - 1) {
        _pages.push(
          <span
            onClick={() => {
              updatePage(1);
            }}
            className={`${
              page === 1 ? "bg-gray-800 text-white" : "text-gray-500"
            } cursor-pointer relative hidden items-center px-4 py-2 text-sm   ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0 md:inline-flex`}
          >
            1
          </span>
        );
        _pages.push(
          <span className="relative hidden items-center px-4 py-2 text-sm  text-gray-500 ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0 md:inline-flex">
            ...
          </span>
        );
        for (let i = totalPages - chunkSize + 1; i <= totalPages; i++) {
          _pages.push(
            <span
              onClick={() => {
                updatePage(i);
              }}
              className={`${
                page === i ? "bg-gray-800 text-white" : "text-gray-500"
              } cursor-pointer relative hidden items-center px-4 py-2 text-sm   ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0 md:inline-flex`}
            >
              {i}
            </span>
          );
        }
      } else {
        _pages.push(
          <span
            onClick={() => {
              updatePage(1);
            }}
            className={`${
              page === 1 ? "bg-gray-800 text-white" : "text-gray-500"
            } cursor-pointer relative hidden items-center px-4 py-2 text-sm   ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0 md:inline-flex`}
          >
            1
          </span>
        );
        _pages.push(
          <span className="relative hidden items-center px-4 py-2 text-sm  text-gray-500 ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0 md:inline-flex">
            ...
          </span>
        );
        for (let i = page - 1; i <= page + 1; i++) {
          _pages.push(
            <span
              onClick={() => {
                updatePage(i);
              }}
              className={`${
                page === i ? "bg-gray-800 text-white" : "text-gray-500"
              } cursor-pointer relative hidden items-center px-4 py-2 text-sm   ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0 md:inline-flex`}
            >
              {i}
            </span>
          );
        }
        _pages.push(
          <span className="relative hidden items-center px-4 py-2 text-sm  text-gray-500 ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0 md:inline-flex">
            ...
          </span>
        );
        _pages.push(
          <span
            onClick={() => {
              updatePage(totalPages);
            }}
            className={`${
              page === totalPages ? "bg-gray-800 text-white" : "text-gray-500"
            } cursor-pointer relative hidden items-center px-4 py-2 text-sm   ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0 md:inline-flex`}
          >
            {totalPages}
          </span>
        );
      }
    }
    setPages(_pages);
  };

  return (
    <div className={`${className || ""} `}>
      <nav
        className="isolate inline-flex -space-x-px rounded-md shadow-sm"
        aria-label="Pagination"
      >
        <button
          onClick={handleDecrement}
          disabled={page === 1}
          className="relative inline-flex items-center rounded-l-md px-2 py-2 disabled:text-gray-400 ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0"
        >
          <svg
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z"
              clipRule="evenodd"
            />
          </svg>
          <span className={cursor ? "" : "sr-only"}>Previous</span>
        </button>
        {!cursor && pages}
        <button
          onClick={handleIncrement}
          disabled={cursor ? isLast : page >= totalPages}
          className="relative inline-flex items-center rounded-r-md px-2 py-2 disabled:text-gray-400 ring-1 ring-inset ring-gray-300 focus:z-20 focus:outline-offset-0"
        >
          <span className={cursor ? "" : "sr-only"}>Next</span>
          <svg
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </nav>
    </div>
  );
}
export default Paginator;
